// extracted by mini-css-extract-plugin
export default {"container":"navbar-item_container__EKuqY","icon-container":"navbar-item_icon-container__QxH69","label":"navbar-item_label__lqV6A"};